import {IonicPage, NavParams, ViewController} from "ionic-angular";
import {Component} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {UserAuthProvider} from "../../../modules/mrk-user-auth/user-auth";
import {PaymentMethods, paymentMethodsStrings} from "../../../models/models";

@IonicPage()
@Component({
  selector: 'deposit-payment-method-modal',
  templateUrl: 'deposit-payment-method-modal.html'
})
export class DepositPaymentMethodModal {
  baseUrl: string

  shopOrderId: number
  selectedPaymentMethod: PaymentMethods

  selectablePaymentMethods: PaymentMethods[] = [
    PaymentMethods.CASH,
    PaymentMethods.BANK_TRANSFER,
    PaymentMethods.BANK_CHECK,
    PaymentMethods.CASH_MACHINE
  ]

  paymentMethodsStrings = paymentMethodsStrings

  constructor(
    public navParams: NavParams,
    private http: HttpClient,
    private userProvider: UserAuthProvider<any>,
    private viewCtrl: ViewController
  ) {
    console.log('ciaos')
    this.baseUrl = this.userProvider.config.baseURL
    this.shopOrderId = this.navParams.get('shopOrderId')
  }

  updateDepositPaymentMethod() {
    let data = {
      shop_order: this.shopOrderId,
      deposit_pay_method: this.selectedPaymentMethod
    }

    this.http.post<any>(`${this.baseUrl}api/shop-pay-methods/update_deposit_pay_method/`, data)
      .subscribe(() => this.viewCtrl.dismiss().then())
  }

  dismissModal() {
    this.viewCtrl.dismiss().then()
  }
}



// WEBPACK FOOTER //
// ./src/pages/meeting/deposit-payment-method-modal/deposit-payment-method-modal.ts